import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={17.785}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 8365 12088"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#231f20}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974319849696">
        <path
          d="M0 0h8365v3045H0zM0 4094h3873v513h-604l573 6504H2761v977h2842v-977H4522l573-6504h-603v-513h3873v-696H0z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
